import { Modal, Spin, SpinProps } from "antd";
import { MessageInstance } from "antd/es/message/interface";
import useMessage from "antd/es/message/useMessage";
import { HookAPI } from "antd/es/modal/useModal";
import { createContext, ReactNode, useContext, useState } from "react";

export interface Feedback {
  message: MessageInstance;
  modal: HookAPI;
  spin: React.Dispatch<React.SetStateAction<SpinProps>>;
}

const Context = createContext<Feedback | null>(null);

export const FeedbackProvider = ({ children }: { children: ReactNode }) => {
  const [message, messageContext] = useMessage();
  const [modal, modalContext] = Modal.useModal();
  const [spinProps, spin] = useState<SpinProps>({
    spinning: false,
    fullscreen: true,
  });

  return (
    <Context.Provider value={{ message, modal, spin }}>
      {children}
      {modalContext}
      <Spin {...spinProps} />
      {messageContext}
    </Context.Provider>
  );
};

export const useFeedback = () => {
  const context = useContext(Context);
  if (context === undefined) {
    throw new Error("useFeedback must be used within a FeedbackProvider");
  }
  return context;
};
